import {
  FormControlLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import CustomTable from "../components/customTable";
import { ConfirmationModal } from "../components/modal";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomizedSnackbars from "../components/snackbar";
import { useGetAdminUsersQuery, useGetRolesQuery, useUpdateAdminMutation } from "../redux/api";
import { getFormatedDate } from "../utils/common";
import { ROUTES } from "../utils/routes";
import { FORM_SELECTFIELD_STYLES } from "../utils/constant";



const AdminUser = () => {
  const navigate = useNavigate();
  const states = useSelector((state) => state.app);
  const [pagination, setPagination] = React.useState({ rows: 10, page: 0 });

  const [deleteModalState, setDeleteModalState] = React.useState({
    open: false,
    id: null,
    message: null,
  });
  const [row, setRow] = React.useState({})
  const [count, setCount] = React.useState(0);
  const [updateAdmin] = useUpdateAdminMutation();
  const [snackbar, setSnackbar] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });

  const handlePageChange = (data) => {
    setPagination(data);
  };

  const Action = (row) => {

    let { id, isActive, roleId } = row

    isActive = isActive == 1 ? false : true



    return (
      <>
        <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} />
        <Stack direction={"row"} sx={{ alignItems: 'center' }} gap={1}>
          {states?.permissions?.adminUsers?.edit === 1 &&
            <div className="actBtnGrps">
              <span className="editIcon" onClick={() => navigate(`${ROUTES.ADMIN_USERS}${ROUTES.EDIT}/${id}`)}>Edit</span>
            </div>
          }

          <FormControlLabel
            className="toogleBtn"
            sx={{
              display: "block",
            }}
            control={
              <Switch
                checked={!isActive}
                onClick={() => {
                  setDeleteModalState({
                    id,
                    open: true,
                    message: `Are you sure you want to ${!isActive ? "Inactive" : "active"} this user ?`, //${row.name}
                  });
                  setRow({
                    id, isActive, roleId
                  })
                }}
                color="success"
              />
            }
          />
        </Stack>
      </>
    );
  };


  const handleDeleteInfluencer = (id) => {
    updateAdmin(row).then((res) => {
      setDeleteModalState({ ...deleteModalState, open: false });
      setSnackbar({
        open: true,
        message: res.data.message,
        severity: res.status == "FAILURE" ? "error" : "success",
      });
    });
  };

  const [filter, setFilter] = React.useState({});

  const handleChange = (e) => {

    if (e.target.value == "All") {
      setFilter({});
    } else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  };

  const [adminData, setAdminData] = React.useState([]);

  const { isSuccess, data } = useGetAdminUsersQuery({
    offset: pagination.page * pagination.rows,
    limit: pagination.rows,
    filter: JSON.stringify(filter),
  });

  const { data: rolesData, isLoading: roleLoading } = useGetRolesQuery();
  const [roleDetails, setRoleDetails] = React.useState(data?.result.data || []);


  React.useEffect(() => {
    if (isSuccess && data && data.status === "SUCCESS") {
      setAdminData(data.result.data);
      setCount(data?.result.count);
    }
  }, [isSuccess, data]);

  React.useEffect(() => {
    if (rolesData && rolesData.status === "SUCCESS") {
      const userData = rolesData?.result.data;
      setRoleDetails(userData)
    }
  }, [roleLoading, data])

  const cols = ["name", "username", "role", "last_activity"];
  const tableData = [];

  if (adminData.length > 0) {
    for (const key of adminData) {
      key.email && tableData.push({
        name: key.adminName,
        id: key.id,
        username: key.email,
        role: key.roleName,
        last_activity: getFormatedDate(key.updatedDate, "MM/DD/YYYY hh:mmA"),
        isActive: key.isActive,
        roleId: key.roleId
      });
    }
  }

  return (
    <Stack direction={"column"} gap={2}>
      <Stack
        className="mainTitle flex-wrap"
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{
          minHeight: '42px', paddingX: '16px'
        }}
      >
        <Typography className="page-title" variant="h1">Admin User</Typography>
        <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2}>
          <Select
            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '250px', width: '250px' }}
            MenuProps={{
              PaperProps: {
                sx: {
                  borderRadius: "8px",
                  mt: 1,
                },
              },
            }}
            value={filter.roleId}
            name="roleId"
            onChange={handleChange}
            displayEmpty
            defaultValue={""}
          >
            <MenuItem value="" disabled hidden>
              Roles
            </MenuItem>
            <MenuItem value="All" >
              Roles (All)
            </MenuItem>


            {roleDetails &&
              roleDetails?.length > 0 && roleDetails.map(
                (role) =>
                  role && (
                    <MenuItem key={role.roleName} value={role.roleId}>
                      {role.roleName}
                      {roleDetails[role.roleName]}
                    </MenuItem>
                  )
              )}
          </Select>
          <button className="btnPrimary" disabled={!states?.permissions?.adminUsers?.create}
            onClick={() => navigate(`${ROUTES.ADMIN_USERS}${ROUTES.ADD}`)}
          >
            Add User
          </button>
        </Stack>


      </Stack>
      <Box
        sx={{
          backgroundColor: '#fff',
          transition: 'all .5s ease-in-out',
          position: 'relative',
          overflow: 'hidden',
        }}>

        <ConfirmationModal
          open={deleteModalState.open}
          onClose={() =>
            setDeleteModalState({ ...deleteModalState, open: false })
          }
          message={deleteModalState.message}
          onConfirm={() => handleDeleteInfluencer(deleteModalState.id)}
        />
        <CustomTable
          onPageChange={handlePageChange}
          cols={cols}
          count={count}
          data={tableData}
          isCheckbox={false}
          actionComp={Action}
        />
      </Box>
    </Stack>
  );
};

export default AdminUser;
